<template>
  <!-- 地图组件 绘制线段 绘制多边形 绘制矩形 绘制圆形 并显示   -->
  <!-- 调用回显 this.$refs.gdmap.csh(this.lineArr,[],11);（父级页面专属） -->
  <!-- lineArr 是回显数组 格式是从handleOk返回给父级页面的 -->
  <!-- 第二个参数为中心点 -->
  <!-- 第三个参数为层级 -->
  <!-- topBqxs 显示上方按钮的个数 为空显示全部 line 显示线段 dbx 显示多边形 jx 显示矩形 yx 显示圆形 -->
  
  <j-modal
      :title="title"
      :width="width"
      :visible="visible"
      :confirmLoading="confirmLoading"
      switchFullscreen
      @ok="handleOk"
      @cancel="handleCancel"
      cancelText="关闭">
      <div>
  
        <div class="input-card" style="width: auto;display: flex;" v-if="this.sfysgj">
          <a-button v-if="topBqxs==''|| topBqxs=='line'" @click="drawPolyline" :type="xzxg=='01'?'primary':''">绘制线段</a-button>
          <a-button v-if="topBqxs==''|| topBqxs=='dbx'" @click="drawPolygon" :type="xzxg=='02'?'primary':''">绘制多边形</a-button>
          <a-button v-if="topBqxs==''|| topBqxs=='jx'" @click="drawRectangle" :type="xzxg=='03'?'primary':''">绘制矩形</a-button>
          <a-button v-if="topBqxs==''|| topBqxs=='yx'" @click="drawCircle" :type="xzxg=='04'?'primary':''">绘制圆形</a-button>
  
          <a-button @click="qkfgw" >清空覆盖物</a-button>
          <a-button @click="fhsyb" >清除最上级图层</a-button>
          <div style="position: relative;">
            <div class="ysxzq" @click="xzyszk">
              <a-button class="wsysxz">选择颜色</a-button>
              <div class="wsxzdys" :style="'background:'+activeYs"></div>
            </div>
            
            <div v-if="ysxzqsfdk" role="application" aria-label="Compact color picker" class="vc-compact">
              <ul role="listbox" class="vc-compact-colors">
                <li role="option" aria-label="color:#4D4D4D" @click="zxysxz('rgb(77, 77, 77)')" class="vc-compact-color-item" style="background: rgb(77, 77, 77);">
                  <div class="vc-compact-dot" style="display: none;"></div>
                </li>
                <li role="option" aria-label="color:#999999" @click="zxysxz('rgb(153, 153, 153)')" class="vc-compact-color-item" style="background: rgb(153, 153, 153);">
                  <div class="vc-compact-dot" style="display: none;"></div>
                </li>
                <li role="option" aria-label="color:#FFFFFF" @click="zxysxz('rgb(255, 255, 255)')" class="vc-compact-color-item vc-compact-color-item--white" style="background: rgb(255, 255, 255);">
                  <div class="vc-compact-dot" style="display: none;"></div>
                </li>
                <li role="option" aria-label="color:#F44E3B" @click="zxysxz('rgb(244, 78, 59)')" class="vc-compact-color-item" style="background: rgb(244, 78, 59);">
                  <div class="vc-compact-dot" style="display: none;"></div>
                </li>
                <li role="option" aria-label="color:#FE9200" @click="zxysxz('rgb(254, 146, 0)')" class="vc-compact-color-item" style="background: rgb(254, 146, 0);">
                  <div class="vc-compact-dot" style="display: none;"></div>
                </li>
                <li role="option" aria-label="color:#FCDC00" @click="zxysxz('rgb(252, 220, 0)')" class="vc-compact-color-item" style="background: rgb(252, 220, 0);">
                  <div class="vc-compact-dot" style="display: none;"></div>
                </li>
                <li role="option" aria-label="color:#DBDF00" @click="zxysxz('rgb(219, 223, 0)')" class="vc-compact-color-item" style="background: rgb(219, 223, 0);">
                  <div class="vc-compact-dot" style="display: none;"></div>
                </li>
                <li role="option" aria-label="color:#A4DD00" @click="zxysxz('rgb(164, 221, 0)')" class="vc-compact-color-item" style="background: rgb(164, 221, 0);">
                  <div class="vc-compact-dot" style="display: none;"></div>
                </li>
                <li role="option" aria-label="color:#68CCCA" @click="zxysxz('rgb(104, 204, 202)')" class="vc-compact-color-item" style="background: rgb(104, 204, 202);">
                  <div class="vc-compact-dot" style="display: none;"></div>
                </li>
                <li role="option" aria-label="color:#73D8FF" @click="zxysxz('rgb(115, 216, 255)')" class="vc-compact-color-item" style="background: rgb(115, 216, 255);">
                  <div class="vc-compact-dot" style="display: none;"></div>
                </li>
                <li role="option" aria-label="color:#AEA1FF" @click="zxysxz('rgb(174, 161, 255)')" class="vc-compact-color-item" style="background: rgb(174, 161, 255);">
                  <div class="vc-compact-dot" style="display: none;"></div>
                </li>
                <li role="option" aria-label="color:#FDA1FF" @click="zxysxz('rgb(253, 161, 255)')" class="vc-compact-color-item" style="background: rgb(253, 161, 255);">
                  <div class="vc-compact-dot" style="display: none;"></div>
                </li>
                <li role="option" aria-label="color:#333333" @click="zxysxz('rgb(51, 51, 51)')" class="vc-compact-color-item" style="background: rgb(51, 51, 51);">
                  <div class="vc-compact-dot" style="display: none;"></div>
                </li>
                <li role="option" aria-label="color:#808080" @click="zxysxz('rgb(128, 128, 128)')" class="vc-compact-color-item" style="background: rgb(128, 128, 128);">
                  <div class="vc-compact-dot" style="display: none;"></div>
                </li>
                <li role="option" aria-label="color:#CCCCCC" @click="zxysxz('rgb(204, 204, 204)')" class="vc-compact-color-item" style="background: rgb(204, 204, 204);">
                  <div class="vc-compact-dot" style="display: none;"></div>
                </li>
                <li role="option" aria-label="color:#D33115" @click="zxysxz('rgb(211, 49, 21)')" class="vc-compact-color-item" style="background: rgb(211, 49, 21);">
                  <div class="vc-compact-dot" style="display: none;"></div>
                </li>
                <li role="option" aria-label="color:#E27300" @click="zxysxz('rgb(226, 115, 0)')" class="vc-compact-color-item" style="background: rgb(226, 115, 0);">
                  <div class="vc-compact-dot" style="display: none;"></div>
                </li>
                <li role="option" aria-label="color:#FCC400" @click="zxysxz('rgb(252, 196, 0)')" class="vc-compact-color-item" style="background: rgb(252, 196, 0);">
                  <div class="vc-compact-dot" style="display: none;"></div>
                </li>
                <li role="option" aria-label="color:#B0BC00" @click="zxysxz('rgb(176, 188, 0)')" class="vc-compact-color-item" style="background: rgb(176, 188, 0);" aria-selected="true">
                  <div class="vc-compact-dot" style=""></div>
                </li>
                <li role="option" aria-label="color:#68BC00" @click="zxysxz('rgb(104, 188, 0)')" class="vc-compact-color-item" style="background: rgb(104, 188, 0);">
                  <div class="vc-compact-dot" style="display: none;"></div>
                </li>
                <li role="option" aria-label="color:#16A5A5" @click="zxysxz('rgb(22, 165, 165)')" class="vc-compact-color-item" style="background: rgb(22, 165, 165);">
                  <div class="vc-compact-dot" style="display: none;"></div>
                </li>
                <li role="option" aria-label="color:#009CE0" @click="zxysxz('rgb(0, 156, 224)')" class="vc-compact-color-item" style="background: rgb(0, 156, 224);">
                  <div class="vc-compact-dot" style="display: none;"></div>
                </li>
                <li role="option" aria-label="color:#7B64FF" @click="zxysxz('rgb(123, 100, 255)')" class="vc-compact-color-item" style="background: rgb(123, 100, 255);">
                  <div class="vc-compact-dot" style="display: none;"></div>
                </li>
                <li role="option" aria-label="color:#FA28FF" @click="zxysxz('rgb(250, 40, 255)')" class="vc-compact-color-item" style="background: rgb(250, 40, 255);">
                  <div class="vc-compact-dot" style="display: none;"></div>
                </li>
                <li role="option" aria-label="color:#000000" @click="zxysxz('rgb(0, 0, 0)')" class="vc-compact-color-item" style="background: rgb(0, 0, 0);">
                  <div class="vc-compact-dot" style="display: none;"></div>
                </li>
                <li role="option" aria-label="color:#666666" @click="zxysxz('rgb(102, 102, 102)')" class="vc-compact-color-item" style="background: rgb(102, 102, 102);">
                  <div class="vc-compact-dot" style="display: none;"></div>
                </li>
                <li role="option" aria-label="color:#B3B3B3" @click="zxysxz('rgb(179, 179, 179)')" class="vc-compact-color-item" style="background: rgb(179, 179, 179);">
                  <div class="vc-compact-dot" style="display: none;"></div>
                </li>
                <li role="option" aria-label="color:#9F0500" @click="zxysxz('rgb(159, 5, 0)')" class="vc-compact-color-item" style="background: rgb(159, 5, 0);">
                  <div class="vc-compact-dot" style="display: none;"></div>
                </li>
                <li role="option" aria-label="color:#C45100" @click="zxysxz('rgb(196, 81, 0)')" class="vc-compact-color-item" style="background: rgb(196, 81, 0);">
                  <div class="vc-compact-dot" style="display: none;"></div>
                </li>
                <li role="option" aria-label="color:#FB9E00" @click="zxysxz('rgb(251, 158, 0)')" class="vc-compact-color-item" style="background: rgb(251, 158, 0);">
                  <div class="vc-compact-dot" style="display: none;"></div>
                </li>
                <li role="option" aria-label="color:#808900" @click="zxysxz('rgb(128, 137, 0)')" class="vc-compact-color-item" style="background: rgb(128, 137, 0);">
                  <div class="vc-compact-dot" style="display: none;"></div>
                </li>
                <li role="option" aria-label="color:#194D33" @click="zxysxz('rgb(25, 77, 51)')" class="vc-compact-color-item" style="background: rgb(25, 77, 51);">
                  <div class="vc-compact-dot" style="display: none;"></div>
                </li>
                <li role="option" aria-label="color:#0C797D" @click="zxysxz('rgb(12, 121, 125)')" class="vc-compact-color-item" style="background: rgb(12, 121, 125);">
                  <div class="vc-compact-dot" style="display: none;"></div>
                </li>
                <li role="option" aria-label="color:#0062B1" @click="zxysxz('rgb(0, 98, 177)')" class="vc-compact-color-item" style="background: rgb(0, 98, 177);">
                  <div class="vc-compact-dot" style="display: none;"></div>
                </li>
                <li role="option" aria-label="color:#653294" @click="zxysxz('rgb(101, 50, 148)')" class="vc-compact-color-item" style="background: rgb(101, 50, 148);">
                  <div class="vc-compact-dot" style="display: none;"></div>
                </li>
                <li role="option" aria-label="color:#AB149E" @click="zxysxz('rgb(171, 20, 158)')" class="vc-compact-color-item" style="background: rgb(171, 20, 158);">
                  <div class="vc-compact-dot" style="display: none;"></div>
                </li>
              </ul>
            </div>
          </div>
          
        </div>
  
        <div id="container" style="width:100%;height:600px"></div>
  
        
      </div>
    </j-modal>
  </template>
  <link rel="stylesheet" href="https://a.amap.com/jsapi_demos/static/demo-center/css/demo-center.css" />
  <script src="https://webapi.amap.com/maps?v=1.4.15&key=98c4ab414f02d3f50f379a25f0f5748&KEY=MouseTool"></script>
  <script>
  
    import pick from 'lodash.pick'
    import JFormContainer from '@/components/jeecg/JFormContainer'
    import { getAction } from '@/api/manage'
  
    let mouseTool;
    let lineObj;
  
    export default {
      name: 'map',
      props: {
        centerArr:{
          type:Array,
          default: () => [106.673217,33.153636]
        },
        mapZoom:{
          type:Number,
          default:10
        },
        topBqxs:{
          type:String,
          default:""
        }
        
      },
      components: {
        JFormContainer,
      },
      data () {
        let self = this;
        return {
          title: '地图坐标',
          visible: false,
          confirmLoading: false,
          width:800,
          map:null,
          center:[],
          zoom:11,
          lineArr:[],
          list2:[],
          xzxg:"",
          sfysgj:true,
          activeYs:"rgb(252, 220, 0)",
          ysxzqsfdk:false,
          id:""
        }
      },
      created () {
        //如果是流程中表单，则需要加载流程表单data
        this.$nextTick(() => { 
          
        })
      },
      mounted(){
        
      },
      methods: {
        csh(lineArrr,centerArr,mapZoom,sfysgj,id){
          this.id = id;
          this.sfysgj=sfysgj;
          this.xzxg='';
          this.lineArr=[];
          for(var i=0;i<lineArrr.length;i++){
            this.lineArr.push(lineArrr[i]);
          }
          if(centerArr!=null){
            this.center = centerArr;
          }else{
            this.center = [106.673217,33.153636];
          }
          
          if(this.center!=null){
            this.zoom = mapZoom;
          }else{
            this.zoom = 13;
          }
          
          this.showModal();
          var that = this;
          setTimeout(() => {
              var map = new AMap.Map('container', {
                  zoom:that.zoom,//级别
                  center: that.center,//中心点坐标
                  viewMode:'3D'//使用3D视图
              });
              this.map = map;
              map.plugin(["AMap.MouseTool"],function(){ 
                mouseTool = new AMap.MouseTool(map); 
  
                mouseTool.on('draw', function(event) {
                  var newArr = [];
                  if(that.xzxg=="04"){
                    that.lineArr.push({type:that.xzxg,'center':[event.obj.De.center.lng,event.obj.De.center.lat],"radius":event.obj.De.radius,"background":that.activeYs});
                  }else{
                     var oldArr = event.obj.getPath();
                     that.lineArr.push({type:that.xzxg,'Arr':oldArr,"background":that.activeYs});
                  }
                  // event.obj 为绘制出来的覆盖物对象
                  // log.info('覆盖物对象绘制完成')
                })
                if(that.lineArr.length>0){
                  that.zdht(map,that.lineArr,"01",null);
                }else{
                  map.clearMap();
                }

                that.pqjz();
                
              });
              
          }, 200);
          
        },
        showModal() {
          this.visible = true;
        },
        handleOk(e) {
          // var arr = lineObj.getPath();
          this.confirmLoading = true;
          
          let mapObj = {
            lineArr:this.lineArr,
          }
          this.$emit('ok',mapObj);
  
          this.visible = false;
          this.confirmLoading = false;
          
        },
        handleCancel(e) {
          console.log('Clicked cancel button');
          this.visible = false;
        },
        pqjz(){
          let that = this;
          getAction('/yqfk/departpq/page',{'pageSize':100000}).then((res)=>{
            if(res.success){
              that.list2 = res.result.records;

              for(var i=0;i<that.list2.length;i++){
                if(that.list2[i].pqlk !=null && that.list2[i].pqlk.length>0 && that.id!=that.list2[i].id){
                  var pqlk = eval(that.list2[i].pqlk);
                  that.zdht(that.map,pqlk,"02",that.list2[i])
                }
              }
            }
          })

        },
        drawPolyline () {
          this.xzxg="01";
          // this.amap = amapManager.getMap();
          // this.mouseTool = new AMap.MouseTool(this.amap);
          mouseTool.polyline({
            strokeColor: this.activeYs, 
            strokeOpacity: 1,
            strokeWeight: 2,
            // 线样式还支持 'dashed'
            strokeStyle: "solid",
            // strokeStyle是dashed时有效
            // strokeDasharray: [10, 5],
          });
  
        },
        drawPolygon () {
          this.xzxg="02";
          mouseTool.polygon({
            strokeColor: "#1791fc", 
            strokeOpacity: 1,
            strokeWeight: 2,
            fillColor: this.activeYs,
            fillOpacity: 0.4,
            // 线样式还支持 'dashed'
            strokeStyle: "solid",
            // strokeStyle是dashed时有效
            // strokeDasharray: [30,10],
          })
        },
        drawRectangle () {
          this.xzxg="03";
          mouseTool.rectangle({
            strokeColor:"#1791fc",
            strokeOpacity:1,
            strokeWeight: 2,
            fillColor:this.activeYs,
            fillOpacity:0.5,
            // strokeStyle还支持 solid
            strokeStyle: 'solid',
            // strokeDasharray: [30,10],
          })
        },
        drawCircle () {
          this.xzxg="04";
          mouseTool.circle({
            strokeColor: "#1791fc",
            strokeOpacity: 1,
            strokeWeight: 2,
            fillColor: this.activeYs,
            fillOpacity: 0.4,
            strokeStyle: 'solid',
            // 线样式还支持 'dashed'
            // strokeDasharray: [30,10],
          })
        },
        zdht(map,pqlk,type,object){
          var qbtc = [];
          for(var i=0;i<pqlk.length;i++){
            var mm = pqlk[i];
            var circle;
            var hdArr = [];
            if(mm.type=="01"){
              circle=new AMap.Polyline({
                  path: mm.Arr,  // 设置线覆盖物路径
                  strokeColor: (mm.background!=undefined&&mm.background!=null)?mm.background:'rgb(252, 220, 0)', 
                  strokeOpacity: 1,
                  strokeWeight: 2,
                  // 线样式还支持 'dashed'
                  strokeStyle: "solid",
              });
            }else if(mm.type=="04"){
              circle=new AMap.Circle({
                center : mm.center,  // 设置线覆盖物路径
                radius : mm.radius,
                strokeColor: "#1791fc",
                strokeOpacity: 1,
                strokeWeight: 2,
                fillColor:  (mm.background!=undefined&&mm.background!=null)?mm.background:'rgb(252, 220, 0)',
                fillOpacity: 0.4,
                strokeStyle: 'solid',
              })
            }else if(mm.type=="02" || mm.type=="03"){
              var newArr = [];
              for(var m=0;m<mm.Arr.length;m++){
                newArr.push([mm.Arr[m].lng,mm.Arr[m].lat])
              }
              circle=new AMap.Polygon({
                path: newArr,  // 设置线覆盖物路径
                strokeColor: "#1791fc", 
                strokeOpacity: 1,
                strokeWeight: 2,
                fillColor:  (mm.background!=undefined&&mm.background!=null)?mm.background:'rgb(252, 220, 0)',
                fillOpacity: 0.4,
                // 线样式还支持 'dashed'
                strokeStyle: "solid",
              })
            }
            map.add(circle);
            // 缩放地图到合适的视野级别
            qbtc.push(circle);
          }
          if(type=="02"){
            this.markerPoint(object);
          }
          
          // map.setFitView(qbtc);
        },
        qkfgw(){
          this.lineArr = [];
          this.map.clearMap();

          for(var i=0;i<this.list2.length;i++){
            if(this.list2[i].pqlk !=null && this.list2[i].pqlk.length>0  && this.id!=this.list2[i].id){
              var pqlk = eval(this.list2[i].pqlk);
              this.zdht(this.map,pqlk,"02",this.list2[i])
            }
          }

        },
        fhsyb(){
          var newArr=[];
          for(var i=0;i<this.lineArr.length-1;i++){
            newArr.push(this.lineArr[i]);
          }
  
          this.lineArr = newArr;
          this.map.clearMap();
          this.zdht(this.map,this.lineArr,"01",null)

          for(var i=0;i<this.list2.length;i++){
            if(this.list2[i].pqlk !=null && this.list2[i].pqlk.length>0 && this.id!=this.list2[i].id){
              var pqlk = eval(this.list2[i].pqlk);
              this.zdht(this.map,pqlk,"02",this.list2[i])
            }
          }

        },
        xzyszk(){
          this.ysxzqsfdk = !this.ysxzqsfdk;
  
        },
        markerPoint(itt){
          
          var dglk = eval(itt.pqlk);
          for(var m=0;m<dglk.length;m++){
            var mm = dglk[m];
            var lnglatarr = mm.Arr;
            var total = lnglatarr.length;
            var X = 0,
              Y = 0,
              Z = 0;
            lnglatarr.map((item) => {
              var lng = (item.lng * Math.PI) / 180;
              var lat = (item.lat * Math.PI) / 180;
              var x, y, z;
              x = Math.cos(lat) * Math.cos(lng);
              y = Math.cos(lat) * Math.sin(lng);
              z = Math.sin(lat);
              X += x;
              Y += y;
              Z += z;
            });
            X = X / total;
            Y = Y / total;
            Z = Z / total;
            var Lng = Math.atan2(Y, X);
            var Hyp = Math.sqrt(X * X + Y * Y);
            var Lat = Math.atan2(Z, Hyp);
            var newZb = new AMap.LngLat((Lng * 180) / Math.PI, (Lat * 180) / Math.PI);
            
            // 创建纯文本标记
            var text = new AMap.Text({
                text:itt.pqName,
                anchor:'center', // 设置文本标记锚点
                draggable:false,
                cursor:'pointer',
                angle:0,
                style :{
                  "font-size":"15px"
                },
                position: newZb
            });
            text.data = itt;
            // text.on('click', (res) =>{
            //   this.openMapInfo(res.target.data,res.lnglat,this.map);
            // })
  
            text.setMap(this.map);
          }
        },
        zxysxz(e){
          this.activeYs = e;
          this.ysxzqsfdk = false;
          if(this.xzxg=="01"){
            this.drawPolyline();
          }else if(this.xzxg=="02"){
            this.drawPolygon();
          }else if(this.xzxg=="03"){
            this.drawRectangle();
          }else if(this.xzxg=="04"){
            this.drawCircle();
          }
        }
        // mouseTool.on('draw', function(event) {
        //   // event.obj 为绘制出来的覆盖物对象
        //   log.info('覆盖物对象绘制完成')
        // })
  
        
      },
    }
  </script>
  <style scoped>
  .amap-page-container {
    width: 100%;
    height: 400px;
    margin-bottom: 20px;
  }
  </style>
  <style>
  .el-vue-search-box-container {
    margin-top: 10px;
    position: absolute !important;
    width: 80% !important;
    margin-left: 10% !important;
  }
  
  .vc-compact {
      padding-top: 5px;
      padding-left: 5px;
      width: 245px;
      border-radius: 2px;
      box-sizing: border-box;
      box-shadow: 0 2px 10px rgba(0,0,0,.12), 0 2px 5px rgba(0,0,0,.16);
      background-color: #fff;
      position: absolute;
      right: 0;
      z-index: 10;
  }
  
  ul {
      display: block;
      list-style-type: disc;
      margin-block-start: 1em;
      margin-block-end: 1em;
      margin-inline-start: 0px;
      margin-inline-end: 0px;
      padding-inline-start: 40px;
  }
  
  
  .vc-compact-colors {
      overflow: hidden;
      padding: 0;
      margin: 0;
  }
  
  .vc-compact-color-item {
      list-style: none;
      width: 15px;
      height: 15px;
      float: left;
      margin-right: 5px;
      margin-bottom: 5px;
      position: relative;
      cursor: pointer;
  }
  
  .wsysxz{
    position: relative;
    background: #41acff !important;
    color: #fff !important;
    border: none;
  }
  
  .ysxzq{
      display: flex;
      position: relative;
      background: #41acff !important;
      padding-right: 13px;
  }
  
  .wsxzdys{
    width: 15px;
    height: 15px;
    margin: auto;
  }
  </style>